var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_metaMap.js
// module id = 346
// module chunks = 0